<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <router-link :to="{ name: 'home' }">{{
                $t("inicio")
              }}</router-link>
            </li>
            <li class="breadcrumb-item active" aria-current="page">
              <router-link :to="{ name: 'configuracion-carta' }">
                {{ $t("configuracionCarta") }}</router-link
              >
            </li>
            <li class="breadcrumb-item active" aria-current="page">
              {{ $t("categoriasCarta") }}
            </li>
          </ol>
        </nav>
      </div>

      <div class="col-md-12">
        <div class="card">
          <div class="row">
            <div class="col-md-5">
              <div class="form-group">
                <label for="listBusiness"
                  ><strong>{{ $t("negocio") }}</strong></label
                >

                <el-select
                  class="select-default"
                  size="large"
                  v-model="idBusiness"
                  filterable
                  @change="permisoCarta()"
                  :placeholder="this.$i18n.t('seleccionaNegocio')"
                >
                  <el-option
                    v-for="business in listBusinesses"
                    class="select-primary"
                    :value="business.id"
                    :label="business.establishmentName"
                    :key="business.id"
                  >
                  </el-option>
                </el-select>                  
              </div>
            </div>
          </div>
        </div>

      </div>
      <!--TABLA DE GESTION DE CONFIGURACION DE CATEGORIAS-->
        <template v-if="permiso === 1"> </template>
        <template v-else-if="permiso && respuesta && !esSelfi">
          <div class="col-md-2">
            <div class="form-group">
              <router-link
                :to="{
                  name: 'categoria-carta',
                  params: { idBusiness: idBusiness },
                }"
              >
                <button class="btn btn-primary">
                  <i class="fa fa-plus-square"></i>
                  {{ $t("anadirCategoria") }}
                </button>
              </router-link>
            </div>
          </div>

          <div
            class="col-md-2 text-right"
            v-tooltip.top-center="$t('tolTipMostrarCategoriaDeBaja')"
          >
            <div
              style="margin-top: 4px"
              class="form-group justify-content-center"
            >
              <el-checkbox
                class="form-group"
                v-model="isDeBaja"
                @change="changeIsDeBaja()"
              >
                <strong>{{ $t("buscarCategoriasBaja") }}</strong>
              </el-checkbox>
            </div>
          </div>

          <div class="col-md-3">
            <div style="width: 100%" v-if="tieneCategoriasPadre && !esSelfi">
              <VueToggles
                :style="'float: right;'"
                id="switchZonasBajas"
                @click="cambiarConfigCategoriasPadre()"
                :value="configCategoriasPadre"
                height="35"
                width="140"
                fontSize="14"
                fontWeight="bold"
                :checkedText="$t('activadas')"
                :uncheckedText="$t('desactivadas')"
                checkedBg="#28a745"
                uncheckedBg="lightgrey"
              ></VueToggles>
              <sup style="float: right; padding-top: 5px; padding-right: 5px">
                <i
                  v-tooltip.top-center="$t('categoriasPadreTextoExplicativo')"
                  class="fa fa-question-circle"
                ></i>
              </sup>
              <strong style="float: right; padding-top: 5px">{{
                $t("categoriasPadre")
              }}</strong>
            </div>
          </div>

          <!-- TODO Añadir aqui el switch para activar las categorias padre -->

          <div class="col-md-5 text-right">
            <div class="input-group">
              <input
                type="text"
                class="form-control"
                v-bind:placeholder="$t('buscar')"
                v-model="searchQuery"
                @keyup.enter.prevent="searchCategoriesCarta()"
              />
              <div class="input-group-append">
                <button
                  class="btn btn-secondary"
                  type="button"
                  @click="searchCategoriesCarta()"
                >
                  <i class="fa fa-search"></i>
                </button>
                <button
                  class="btn btn-secondary"
                  type="button"
                  @click="removeCategoriasCarta()"
                >
                  <i class="fa fa-times"></i>
                </button>
              </div>
            </div>
          </div>

          <div class="col-md-12">
            <div class="table-responsive">
              <table class="table table-bordered table-striped">
                <thead class="thead-dark">
                  <tr>
                    <th></th>
                    <th v-if="tieneCategoriasPadre && !esSelfi">
                      {{ $t("imagen") }}
                      <sup>
                        <i
                          v-tooltip.top-center="
                            $t('lasImagenesSoloSeraVisibleEnLasCategoriasPadre')
                          "
                          class="fa fa-question-circle"
                        ></i>
                      </sup>
                    </th>
                    <th>{{ $t("nombre") }}</th>
                    <th v-if="tieneCategoriasPadre && !esSelfi">
                      {{ $t("categoriasPadre") }}
                    </th>
                    <th width="20%">{{ $t("acciones") }}</th>
                  </tr>
                </thead>
                <tbody is="draggable" tag="tbody" v-bind="dragOptions" @end="onDragEnd">
                  <tr v-for="obj in listCategoriasCarta" :key="obj.id" :data-id="obj.id" :data-index="index" :data-categoria="obj" >
                    <td width="4%" style="text-align: center;">
                      <div class="drag-handle">
                          <i v-tooltip.top-center="$i18n.t('sort')"
                              class="fas fa-bars">
                          </i>
                      </div>

                    </td>
                    <td width="5%" v-if="tieneCategoriasPadre && !esSelfi">
                      <div>
                        <template v-if="obj.img">
                          <img
                            @click="openModalEditar(obj)"
                            width="100%"
                            :src="obj.img + '?' + obj.updated"
                          />
                        </template>
                        <template v-else>
                          <img
                            @click="openModalEditar(obj)"
                            width="100%"
                            src="https://www.numier.com/cartadigital/no-products.png"
                          />
                        </template>
                      </div>
                    </td>
                    <td>
                      <div>
                        {{ obj.nombre }}
                        <span v-if="obj.baja != 0" style="color: red">
                          [{{ $t("BAJA") }}]
                        </span>
                      </div>
                    </td>
                    <td v-if="tieneCategoriasPadre && !esSelfi">
                      <div>
                        <el-select
                          class="select-default"
                          size="large"
                          v-model="obj.idPadre"
                          v-if="obj.idPadre != -1"
                          @change="asignarCategoriaPadre(obj)"
                          filterable
                          :placeholder="$t('seleccionaCategoria')"
                        >
                          <el-option
                            v-for="catPa in listCategoriasPadre"
                            class="select-primary"
                            :value="catPa.id"
                            :label="catPa.nombre"
                            :key="catPa.id"
                          >
                          </el-option>
                        </el-select>
                        <span v-else>
                          {{ $t("categoriaPadre") }}
                        </span>
                      </div>
                    </td>
                    <td align="center">
                      <div>
                        <div
                          class="btn btn-link btn-xs"
                          :key="configcarta.toString()"
                          v-tooltip.top-center="$t('tolTipTraducirCategoria')"
                          @click="abrirModalIdiomas(obj)"
                          v-if="configcarta.controlIdiomas"
                        >
                          <i
                            class="fas fa-globe-americas"
                            style="color: #1f51ff"
                          ></i>
                        </div>

                        <div
                          class="btn btn-link btn-xs"
                          v-tooltip.top-center="
                            $t('tolTipConvertirCategoriaPadre')
                          "
                          @click="convertirCategoriaPadre(obj)"
                          v-if="!esSelfi"
                        >
                          <i
                            class="fas fa-sitemap"
                            :style="[
                              obj.idPadre == -1 ? { color: 'green' } : '',
                            ]"
                          ></i>
                        </div>

                        <router-link
                          class="btn btn-warning btn-link btn-xs"
                          :to="{
                            name: 'categoria-carta',
                            params: {
                              idBusiness: idBusiness,
                              idCategoria: obj.id,
                            },
                          }"
                        >
                          <i
                            style="color: orange"
                            v-tooltip.top-center="$i18n.t('editar')"
                            class="fas fa-pencil-alt"
                          ></i>
                        </router-link>

                        <i
                          v-if="obj.baja == 0"
                          @click="openBorrarCategoria(obj)"
                          class="fas fa-trash-alt"
                          style="color: red"
                        ></i>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
              <modal
                :name="'anadir-idioma'"
                :adaptive="true"
                :scrollable="true"
                height="auto"
                :clickToClose="false"
              >
                <div>
                  <div class="modal-header">
                    <h4 style="margin: 0px">
                      {{ $t("traduccionDe") }} {{ categoriaEditar.nombre }}
                    </h4>
                  </div>

                  <div class="modal-body">
                    <label for="idioma">{{ $t("idioma") }}:</label>
                    <br />
                    <el-select
                      class="select-default"
                      size="large"
                      v-model="selectedLang"
                      @change="cambiarTraducciones"
                      :placeholder="'Selecciona un idioma'"
                    >
                      <el-option
                        v-for="lang in langList"
                        class="select-primary"
                        :value="lang.idLang"
                        :label="lang.name"
                        :key="lang.idLang"
                      >
                      </el-option>
                    </el-select>
                    <br />
                    <div id="ingles" class="mt-3">
                      <label for="traduccion">{{ $t("nombre") }}: </label>
                      <input
                        id="traduccion"
                        class="form-control"
                        type="text"
                        v-model="traduccion"
                      />
                    </div>
                  </div>
                  <div class="modal-footer">
                    <button
                      class="btn btn-default"
                      @click="(img = ''), $modal.hide('anadir-idioma')"
                    >
                      <i class="fa fa-times-circle"></i> {{ $t("cancelar") }}
                    </button>
                    <button
                      class="btn btn-success"
                      @click="cambiarIdiomaCategoria(categoriaEditar)"
                    >
                      <i class="fa fa-check-circle"></i>
                      {{ $t("guardar") }}
                    </button>
                  </div>
                </div>
              </modal>
              <modal
                :name="'editar-categoria'"
                :adaptive="true"
                :scrollable="true"
                height="auto"
                :clickToClose="false"
              >
                <div>
                  <div class="modal-header">
                    <h4 style="margin: 0px">{{ $t("editarImagen") }}</h4>
                  </div>

                  <div class="modal-body">
                    <template v-if="categoriaEditar.img">
                      <p>
                        <strong>{{ $t("imagen") }}</strong>
                        <span style="color: red">*</span>
                        <i
                          class="fas fa-pencil-alt text-warning"
                          @click="categoriaEditar.img = ''"
                          v-tooltip.top-center="$t('editarImagen')"
                        ></i>
                      </p>
                      <div style="width: 100%">
                        <img
                          width="100%"
                          :src="
                            categoriaEditar.img + '?' + categoriaEditar.updated
                          "
                        />
                      </div>
                    </template>
                    <template v-else>
                      <div class="form-group">
                        <label
                          ><strong>{{ $t("imagen") }}</strong>
                        </label>
                        <input
                          class="form-control"
                          type="file"
                          style="height: 100px"
                          @change="onFileChange"
                        />
                        <br />
                      </div>
                    </template>
                  </div>
                  <div class="modal-footer">
                    <button
                      class="btn btn-default"
                      @click="(img = ''), $modal.hide('editar-categoria')"
                    >
                      <i class="fa fa-times-circle"></i> {{ $t("cancelar") }}
                    </button>
                    <button
                      class="btn btn-success"
                      @click="editarImagen(categoriaEditar)"
                    >
                      <i class="fa fa-check-circle"></i>
                      {{ $t("guardar") }}
                    </button>
                  </div>
                </div>
              </modal>
            </div>
          </div>
        </template>
        <template v-if="!permiso && !esSelfi">
          <div class="col-md-12">
            <div class="alert alert-primary" align="center">
              <h3>
                <i class="fas fa-exclamation-circle"></i>
                {{ $t("esteNegocioNoTieneAccesoAEsteModulo") }}
              </h3>

              <span>
                {{ $t("paraMasInformacionContacteConSu") }}
                <strong>{{ $t("distribuidor") }}</strong
                >.</span
              >
            </div>
          </div>
        </template>
        <template v-if="esSelfi">
                <div class="col-md-12">
                    <div class="alert alert-primary" align="center">
                    <h3>
                        <i class="fas fa-exclamation-circle"></i>
                        {{ $t("nosmudamos") }}
                    </h3>

                    <div style="margin-bottom: 2vh">                
                        {{$t("noscambiamosaselfi") }}
                        .</div>
                    
                    <!-- <a href="http://127.0.0.1:5173/validate-user" target="_blank">
                        {{ $t("paraContinuar") }}
                        <strong>Selfibar</strong>.
                    </a> -->

                    </div>
                        <button class="btn btn-primary" @click="redirectToSelfibar()">{{$t("irASelfibar")}}</button>

                    </div>
                </template>
    </div>
  </div>
</template>

<script>
import {
  DatePicker,
  Select,
  Option,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  Button,
  Checkbox,
} from "element-ui";
import { VueToggles } from "vue-toggles";
import { Loading } from "element-ui";
import swal from "sweetalert2";
import moment from "moment";
import draggable from "vuedraggable";

export default {
  name: "Categorias",
  data() {
    return {
      searchQuery: "",
      listCategoriasCarta: [],
      listCategoriasPadre: [],

      //NEGOCIOS
      listBusinesses: [],
      idBusiness: 0,
      permiso: 1,

      cacheImagen: 0,
      img: "",

      respuesta: false,
      configcarta: {},
      listCartas: [],
      idCarta: 0,
      categoriaEditar: {},
      selectedLang: 0,
      langList: [],
      traduccion: "",
      categoryTranslations: [],
      configCategoriasPadre: false,
      tieneCategoriasPadre: false,
      isDeBaja: false,
      baja: 0,
      esSelfi: false,
      esSelfi: false,

      dragOptions: {
        animation: 150,
        handle: ".drag-handle", // Solo permite arrastrar desde este selector
      },
    };
  },
  created() {
    this.$store.dispatch("setNameRoute", "Categorias carta");
    this.getBusiness();
    this.checkIsSelfi();
  },
  methods: {
    checkIsSelfi() {
      let vm = this;

      const esSelfiCookie = document.cookie
        .split("; ")
        .find((row) => row.startsWith("esSelfi="));

      // Verificar si la cookie existe antes de intentar acceder a su valor
      if (esSelfiCookie) {
        vm.esSelfi = esSelfiCookie.split("=")[1];
      } else {
        vm.esSelfi = false;
      }
    },
    cambiarConfigCategoriasPadre() {
      if (this.tieneCategoriasPadre) {
        swal({
          title: this.configCategoriasPadre
            ? this.$t("deseaDesactivarLasCategoriasPadreParaLaCartaDigital")
            : this.$t("deseaActivarLasCategoriasPadreParaLaCartaDigital"),
          text: this.configCategoriasPadre
            ? ""
            : this.$t(
                "recuerdeQueLasCategoriasQueNoEstenRelacionadasAUnaCategoriaPadreNoApareceranEnLaCartaDigital"
              ),
          type: "warning",
          showCancelButton: true,
          confirmButtonClass: "btn btn-success btn-fill",
          cancelButtonClass: "btn btn-danger btn-fill",
          confirmButtonText: this.$t("aceptar"),
          cancelButtonText: this.$t("cancelar"),
          buttonsStyling: true,
        }).then((result) => {
          if (result.value) {
            this.configCategoriasPadre = !this.configCategoriasPadre;
            this.loading = Loading.service({ text: "Cargando..." });
            var config = {
              params: {
                jwt: this.$store.getters.jwt,
              },
              headers: { Authorization: "Bearer " + this.$store.getters.jwt },
            };
            var params = {
              idTpv: this.idTpv,
              idBusiness: this.idBusiness,
              numConfig: 34,
              valor: this.configCategoriasPadre ? 1 : 0,
              jwt: this.$store.getters.jwt,
            };

            let vm = this;
            this.axios
              .post(
                this.$store.getters.apiUrl + "general/setConfigBusinessInfo",
                params,
                config
              )
              .then(function (response) {
                if (response.data.response) {
                } else {
                  swal({
                    title: vm.$t("atencion"),
                    text: response.data.message,
                    confirmButtonClass: "btn btn-info btn-fill",
                    type: "error",
                  });
                }
              })
              .catch(function (error) {
                console.log(error);
              })
              .finally((_) => {
                vm.loading.close();
              });
          }
        });
      } else {
        swal({
          title: this.$t("atencion"),
          text: this.$t(
            "porFavorAnadaUnaCategoriaPadreAntesDeActivarLaConfiguracion"
          ),
          confirmButtonClass: "btn btn-info btn-fill",
          type: "error",
        });
      }
    },
    editarImagen(obj) {
      let editImage = false;
      if (!obj.img) {
        editImage = true;

        obj.img = this.img;
      }
      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };
      var params = {
        idBusiness: this.idBusiness,
        categoria: obj,
        editImage: editImage,
        jwt: this.$store.getters.jwt,
      };

      let vm = this;
      let controller = "editarImagenCategoriaCarta";
      this.axios
        .post(
          this.$store.getters.apiUrl + "delivery/" + controller,
          params,
          config
        )
        .then(function (response) {
          if (response.data.response) {
            vm.getCategoriasCarta();
            vm.$modal.hide("editar-categoria");

            vm.img = "";

            let notify = vm.$t("editada");
            vm.$notify({
              message:
                vm.$t("imagen") + " " + notify + " " + vm.$t("correctamente"),
              icon: "nc-icon nc-check-2",
              timeout: 2000,
              horizontalAlign: "right",
              verticalAlign: "top",
              type: "success",
            });
          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        })
        .catch(function (error) {
          console.log(error);
          vm.inProgress = false;
        });
    },
    onFileChange(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.createImage(files[0]);
    },
    createImage(file) {
      var reader = new FileReader();
      var vm = this;
      reader.onload = (e) => {
        vm.img = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    openModalEditar(obj) {
      this.cacheImagen++;

      this.categoriaEditar = obj;

      this.$modal.show("editar-categoria");
    },
    asignarCategoriaPadre(categoria) {
      this.loading = Loading.service({ text: this.$t("cargando") });

      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      var params = {
        idBusinessInfo: this.idCarta,
        idCategoria: categoria.id,
        idCategoriaPadre: categoria.idPadre,
        jwt: this.$store.getters.jwt,
      };

      let vm = this;
      let controller = "asignarCategoriaPadre";
      this.axios
        .post(
          this.$store.getters.apiUrl + "categories/" + controller,
          params,
          config
        )
        .then(function (response) {
          vm.loading.close();
          if (response.data.response) {
            vm.getCategoriasCarta();
            let notify = "asignada";

            vm.$notify({
              message:
                vm.$t("categoriaPadre") +
                " " +
                notify +
                " " +
                vm.$t("correctamente"),
              icon: "nc-icon nc-check-2",
              timeout: 2000,
              horizontalAlign: "right",
              verticalAlign: "top",
              type: "success",
            });
          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        })
        .catch(function (error) {
          console.log(error);
          vm.inProgress = false;
        });
    },
    convertirCategoriaPadre(categoria) {
      swal({
        title:
          categoria.idPadre != -1
            ? this.$t("quieresConvertirLaCategoria") +
              " " +
              categoria.nombre +
              " " +
              this.$t("enUnaCategoriaPadre")
            : this.$t("quieresQueLaCategoria") +
              " " +
              categoria.nombre +
              " " +
              this.$t("dejeDeSerUnaCategoriaPadre"),
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-success btn-fill",
        cancelButtonClass: "btn btn-danger btn-fill",
        confirmButtonText: this.$t("aceptar"),
        cancelButtonText: this.$t("cancelar"),
        buttonsStyling: true,
      }).then((result) => {
        if (result.value) {
          this.loading = Loading.service({ text: this.$t("cargando") });

          var config = {
            params: {
              jwt: this.$store.getters.jwt,
            },
            headers: { Authorization: "Bearer " + this.$store.getters.jwt },
          };

          var params = {
            idBusinessInfo: this.idCarta,
            categoria: categoria,
            crearCategoria: categoria.idPadre != -1 ? true : false,
            jwt: this.$store.getters.jwt,
          };

          let vm = this;
          let controller = "cambiarCategoriaPadre";
          this.axios
            .post(
              this.$store.getters.apiUrl + "categories/" + controller,
              params,
              config
            )
            .then(function (response) {
              vm.loading.close();
              if (response.data.response) {
                vm.getCategoriasCarta();

                let notify = "creada";
                vm.$notify({
                  message:
                    vm.$t("categoriaPadre") +
                    " " +
                    notify +
                    " " +
                    vm.$t("correctamente"),
                  icon: "nc-icon nc-check-2",
                  timeout: 2000,
                  horizontalAlign: "right",
                  verticalAlign: "top",
                  type: "success",
                });
              } else {
                swal({
                  title: vm.$t("atencion"),
                  text: response.data.message,
                  confirmButtonClass: "btn btn-info btn-fill",
                  type: "error",
                });
              }
            })
            .catch(function (error) {
              console.log(error);
              vm.inProgress = false;
            });
        }
      });
    },
    borrarCategoria(idCategoria) {
      var config = {
        params: {
          jwt: this.$store.getters.jwt,
          idBusiness: this.idBusiness,
          idCategoria: idCategoria,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };
      var params = {
        idBusiness: this.idBusiness,
        idCategoria: idCategoria,
        jwt: this.$store.getters.jwt,
      };

      let vm = this;
      let controller = "borrarCategoria";
      this.axios
        .post(
          this.$store.getters.apiUrl + "categories/" + controller,
          params,
          config
        )
        .then(function (response) {
          if (response.data.response) {
            vm.getCategoriasCarta();
          }
        })
        .finally((_) => {
          vm.loading.close();
        });
    },
    openBorrarCategoria(obj) {
      swal({
        title: this.$t("atencion"),
        text: this.$t("confirmaEliminarCategoria"),
        confirmButtonClass: "btn btn-info btn-fill",
        confirmButtonText: this.$t("siEliminarCategoria"),
        cancelButtonText: this.$t("cancelar"),
        showCancelButton: true,
      }).then((result) => {
        if (result.value) {
          this.borrarCategoria(obj.id);
        }
      });
    },
    getBusiness() {
      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(this.$store.getters.apiUrl + "general/getBusinessesByUser", config)
        .then(function (response) {
          if (vm.$store.getters.idBusiness) {
            vm.idBusiness = vm.$store.getters.idBusiness;
          } else {
            vm.idBusiness = response.data.result[0].id;
          }

          vm.listBusinesses = response.data.result;

          vm.permisoCarta();
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    permisoCarta() {
      const selectedBusiness = this.listBusinesses.find(
        (business) => business.id == this.idBusiness
      );

     if (selectedBusiness && selectedBusiness.selfi === "1") {
                this.esSelfi = true;

                swal({
                    title: this.$t("nosmudamos"),
                    text: this.$t("noscambiamosaselfi"), // Puedes traducir este texto si usas i18n
                    confirmButtonClass: "btn btn-warning btn-fill",
                    type: "warning",
                    showCloseButton: true, // Muestra la "X" en la esquina superior derecha
                    confirmButtonText: this.$t("irASelfibar"), // Texto del botón de confirmación
                    reverseButtons: true, // Invierte los botones para que el botón de confirmación esté primero
                }).then((result) => {
                    console.log(result);
                    if (result.value) {
                        this.redirectToSelfibar();
                    }
                });
            } else {
                this.esSelfi = false;
        // console.log("no es selfi");
        var config = {
          params: {
            idBusiness: this.idBusiness,
            jwt: this.$store.getters.jwt,
          },
          headers: { Authorization: "Bearer " + this.$store.getters.jwt },
        };
        this.$store.dispatch("setIdBusiness", this.idBusiness);
        let vm = this;
        this.axios
          .get(this.$store.getters.apiUrl + "delivery/getPermisoCarta", config)
          .then(function (response) {
            if (response.data.response) {
              if (response.data.result.permiso) {
                vm.permiso = response.data.result.permiso;
                vm.listCartas = response.data.result.listCartas;
                vm.idCarta = 0;
                vm.idCarta = response.data.result.listCartas[0].id;
                vm.configCategoriasPadre =
                  response.data.result.listCartas[0].categoriasPadre;

                vm.getCategoriasCarta();
              } else {
                vm.permiso = response.data.result.permiso;
              }
            } else {
              swal({
                title: vm.$t("atencion"),
                text: response.data.message,
                confirmButtonClass: "btn btn-info btn-fill",
                type: "error",
              });
            }
          });
      }
    },

    searchCategoriesCarta() {
      var config = {
        params: {
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt,
          query: this.searchQuery,
          baja: this.baja,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.$store.dispatch("setIdBusiness", this.idBusiness);
      this.axios
        .get(
          this.$store.getters.apiUrl + "delivery/searchCategoriesCarta",
          config
        )
        .then(function (response) {
          if (response.data.response) {
            vm.listCategoriasCarta = response.data.result;
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    removeCategoriasCarta() {
      this.getCategoriasCarta();
    },

    getCategoriasCarta() {
      this.tieneCategoriasPadre = false;
      this.listCategoriasPadre = [];

      var config = {
        params: {
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt,
          baja: this.baja,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      this.loading = Loading.service({ text: this.$t("cargando") });

      let vm = this;
      this.$store.dispatch("setIdBusiness", this.idBusiness);
      this.axios
        .get(this.$store.getters.apiUrl + "delivery/getCategoriesCarta", config)
        .then(function (response) {
          if (response.data.response) {
            vm.listCategoriasCarta = response.data.result;

            response.data.result.forEach((cat) => {
              if (cat.idPadre == -1) {
                vm.tieneCategoriasPadre = true;

                vm.listCategoriasPadre.push(cat);
              }
            });

            if (vm.listCategoriasPadre) {
              let category = {
                id: 0,
                idTpv: vm.idTpv,
                orden: 999,
                nombre: vm.$t("sinCategoria"),
                descripcion: "",
                baja: 0,
                idPadre: 0,
                nombrePadre: "",
              };

              vm.listCategoriasPadre.unshift(category);
            }

            vm.respuesta = true;
          } else {
            vm.respuesta = false;

            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }

          vm.loading.close();
        })
        .catch(function (error) {
          console.log(error);
        });

      const tempconfig = this.listCartas.find(
        (elm) => elm.id == this.idCarta
      ).config;

      if (tempconfig && tempconfig.length > 0) {
        tempconfig.forEach((element) => {
          const el = {};
          el[element.nombre] = element.valor != 0;
          Object.assign(this.configcarta, el);
          //  this.configcarta.push(el)
        });
      }
    },

    abrirModalIdiomas(obj) {
      this.categoriaEditar = obj;
      this.getIdiomasCarta();
    },
    getIdiomasCarta() {
      //Conseguimos los idiomas que tiene el negocio para poder mostrárselos

      var config = {
        params: {
          jwt: this.$store.getters.jwt,
          idBusinessInfo: this.idCarta,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      var vm = this;
      this.axios
        .get(vm.$store.getters.apiUrl + "delivery/getLangBusinessInfo", config)
        .then(function (response) {
          if (response.data.response) {
            vm.langList = response.data.result;

            vm.selectedLang = response.data.result[0].idLang;

            if (vm.langList.length > 0) {
              vm.getTraducciones();
            } else {
              swal({
                title: vm.$t("atencion"),
                text: "Su carta no tiene ningún idioma asociado",
                confirmButtonClass: "btn btn-info btn-fill",
                type: "error",
              });
            }
          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        });
    },
    getTraducciones() {
      //Preparamos las id de los idiomas que vamos a utilizar para buscar las traducciones
      let langIdList = [];

      this.langList.forEach((lang) => {
        langIdList.push(lang.idLang);
      });

      var config = {
        params: {
          jwt: this.$store.getters.jwt,
          langList: langIdList,
          idBusinessInfo: this.idCarta,
          idCategory: this.categoriaEditar.id,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      var vm = this;
      this.axios
        .get(
          vm.$store.getters.apiUrl +
            "delivery/getLangCategoryCartaTranslations",
          config
        )
        .then(function (response) {
          if (response.data.response) {
            //Conseguimos las traducciones y seteamos las traducciones del primer idioma que recogimos
            vm.categoryTranslations = response.data.result;

            let idiomaSeleccionado = vm.categoryTranslations.find(
              (element) => element.idLang == vm.selectedLang
            );

            vm.traduccion = idiomaSeleccionado
              ? idiomaSeleccionado.traduccion
              : "";

            vm.$modal.show("anadir-idioma");
          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        });
    },
    cambiarTraducciones() {
      let idiomaSeleccionado = this.categoryTranslations.find(
        (element) => element.idLang == this.selectedLang
      );

      this.traduccion = idiomaSeleccionado ? idiomaSeleccionado.traduccion : "";
    },
    cambiarIdiomaCategoria(obj) {
      if (this.traduccion.trim() === "") {
        swal({
          title: "¡Lo sentimos!",
          text: "No puede guardar en blanco la traducción de un producto",
          confirmButtonClass: "btn btn-info btn-fill",
          type: "error",
        });
      } else {
        //Le añadimos al producto las traducciones
        obj.traduccion = this.traduccion;

        //console.log(obj.id);
        var config = {
          params: {
            jwt: this.$store.getters.jwt,
          },
          headers: { Authorization: "Bearer " + this.$store.getters.jwt },
        };
        var params = {
          idBusinessInfo: this.idCarta,
          categoria: obj,
          jwt: this.$store.getters.jwt,
          idLang: this.selectedLang,
        };

        let vm = this;
        let controller = "cambiarIdiomaACategoria";
        this.axios
          .post(
            this.$store.getters.apiUrl + "delivery/" + controller,
            params,
            config
          )
          .then(function (response) {
            if (response.data.response) {
              vm.getCategoriasCarta();
              vm.$modal.hide("anadir-idioma");
              let notify = "modificada";
              vm.$notify({
                message:
                  vm.$t("traduccion") +
                  " " +
                  notify +
                  " " +
                  vm.$t("correctamente"),
                icon: "nc-icon nc-check-2",
                timeout: 2000,
                horizontalAlign: "right",
                verticalAlign: "top",
                type: "success",
              });
            } else {
              swal({
                title: vm.$t("atencion"),
                text: response.data.message,
                confirmButtonClass: "btn btn-info btn-fill",
                type: "error",
              });
            }
          })
          .catch(function (error) {
            console.log(error);
            vm.inProgress = false;
          });
      }
    },

    changeIsDeBaja() {
      if (this.isDeBaja) {
        this.baja = 1;
      } else {
        this.baja = 0;
      }
      this.getCategoriasCarta();
    },
    redirectToSelfibar() {
      const jwt = this.$store.getters.jwt;

      // Construye la URL con el parámetro JWT
      // const targetUrl = `http://127.0.0.1:5173/validate-user?jwt=${encodeURIComponent(jwt)}`;
      // const targetUrl = `https://dev.selfibar.com/validate-user?jwt=${encodeURIComponent(jwt)}`;
      const targetUrl = `https://selfibar.com/online/validate-user?jwt=${encodeURIComponent(jwt)}`;


      // Abre la URL en una nueva pestaña
      window.open(targetUrl, '_blank');
    },
  
    onDragEnd(event) {

      this.sortCategory(event.item.dataset.id, event.newIndex)
    },

    sortCategory(idCategoria, newPosition) {

      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { 'Authorization': "Bearer " + this.$store.getters.jwt }
      };
      var params = {
        idBusiness: this.idBusiness,
        idCategoria: idCategoria,
        newPosition: newPosition

      };

      let vm = this;

      let controller = 'categories/sortCategory';

      this.axios.post(this.$store.getters.apiUrl + controller, params, config)
        .then(function (response) {
          if (response.data.response) {

            vm.$notify({
              message: vm.$t('categorySorted'),
              icon: 'nc-icon nc-check-2',
              timeout: 2000,
              horizontalAlign: 'right',
              verticalAlign: 'top',
              type: 'success'
            });

          } else {
            swal({
              title: vm.$t('atencion'),
              text: response.data.message,
              confirmButtonClass: 'btn btn-info btn-fill',
              type: 'error'
            });
          }
        }).catch(function (error) {
          console.log(error);
          vm.inProgress = false;
        });
    }
  },
  components: {
    [DatePicker.name]: DatePicker,
    [Select.name]: Select,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Button.name]: Button,
    [Checkbox.name]: Checkbox,
    [Option.name]: Option,
    draggable
  },

  
};


</script>

<style scoped>
.card {
  padding: 20px;
}
</style>



// WEBPACK FOOTER //
// src/pages/Dashboard/Delivery/Configuracion/Categorias/CategoriasCarta.vue